export const actionTypes = {
  ALERT_SUCCESS: "ALERT_SUCCESS",
  ALERT_ERROR: "ALERT_ERROR",
  ALERT_CLOSE: "ALERT_CLOSE",

  FETCH_STUFF: "FETCH_STUFF",
  RECEIVE_STUFF: "RECEIVE_STUFF",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGOUT: "LOGOUT",

  USER_DATA_REQUEST: "USER_DATA_REQUEST",
  USER_DATA_SUCCESS: "USER_DATA_SUCCESS",
  USER_DATA_FAILURE: "USER_DATA_FAILURE",

  RECENTS_REQUEST: "RECENTS_REQUEST",
  RECENTS_SUCCESS: "RECENTS_SUCCESS",
  RECENTS_FAILURE: "RECENTS_FAILURE",

  APPSETTINGS_SUCCESS: "APPSETTINGS_SUCCESS",

  CASETYPES_REQUEST: "CASETYPES_REQUEST",
  CASETYPES_SUCCESS: "CASETYPES_SUCCESS",
  CASETYPES_FAILURE: "CASETYPES_FAILURE",

  CASE_CREATION_PAGE_REQUEST: "CASE_CREATION_PAGE_REQUEST",
  CASE_CREATION_PAGE_SUCCESS: "CASE_CREATION_PAGE_SUCCESS",
  CASE_CREATION_PAGE_FAILURE: "CASE_CREATION_PAGE_FAILURE",

  CASES_REQUEST: "CASES_REQUEST",
  CASES_SUCCESS: "CASES_SUCCESS",
  CASES_FAILURE: "CASES_FAILURE",

  CASE_REQUEST: "CASE_REQUEST",
  CASE_SUCCESS: "CASE_SUCCESS",
  CASE_FAILURE: "CASE_FAILURE",
  CASE_CLOSED: "CASE_CLOSED",

  CASE_REFRESH_REQUEST: "CASE_REFRESH_REQUEST",
  CASE_REFRESH_SUCCESS: "CASE_REFRESH_SUCCESS",
  CASE_REFRESH_FAILURE: "CASE_REFRESH_FAILURE",

  CASE_UPDATE_REQUEST: "CASE_UPDATE_REQUEST",
  CASE_UPDATE_SUCCESS: "CASE_UPDATE_SUCCESS",
  CASE_UPDATE_FAILURE: "CASE_UPDATE_FAILURE",

  CASE_CREATE_REQUEST: "CASE_CREATE_REQUEST",
  CASE_CREATE_SUCCESS: "CASE_CREATE_SUCCESS",
  CASE_CREATE_FAILURE: "CASE_CREATE_FAILURE",

  CASE_PAGE_REQUEST: "CASE_PAGE_REQUEST",
  CASE_PAGE_SUCCESS: "CASE_PAGE_SUCCESS",
  CASE_PAGE_FAILURE: "CASE_PAGE_FAILURE",

  CASE_VIEW_REQUEST: "CASE_VIEW_REQUEST",
  CASE_VIEW_SUCCESS: "CASE_VIEW_SUCCESS",
  CASE_VIEW_FAILURE: "CASE_VIEW_FAILURE",

  REMOVE_PAGE: "REMOVE_PAGE",

  ASSIGNMENTS_REQUEST: "ASSIGNMENTS_REQUEST",
  ASSIGNMENTS_SUCCESS: "ASSIGNMENTS_SUCCESS",
  ASSIGNMENTS_FAILURE: "ASSIGNMENTS_FAILURE",

  ASSIGNMENT_REQUEST: "ASSIGNMENT_REQUEST",
  ASSIGNMENT_SUCCESS: "ASSIGNMENT_SUCCESS",
  ASSIGNMENT_FAILURE: "ASSIGNMENT_FAILURE",
  ASSIGNMENT_CLOSED: "ASSIGNMENT_CLOSED",
  ASSIGNMENT_CHANGED: "ASSIGNMENT_CHANGED",

  ASSIGNMENT_REVIEW_MODE: "ASSIGNMENT_REVIEW_MODE",
  ADD_OPEN_ASSIGNMENT: "ADD_OPEN_ASSIGNMENT",

  ASSIGNMENT_FIELDS_REQUEST: "ASSIGNMENT_FIELDS_REQUEST",
  ASSIGNMENT_FIELDS_SUCCESS: "ASSIGNMENT_FIELDS_SUCCESS",
  ASSIGNMENT_FIELDS_FAILURE: "ASSIGNMENT_FIELDS_FAILURE",

  ASSIGNMENT_REFRESH_REQUEST: "ASSIGNMENT_REFRESH_REQUEST",
  ASSIGNMENT_REFRESH_SUCCESS: "ASSIGNMENT_REFRESH_SUCCESS",
  ASSIGNMENT_REFRESH_FAILURE: "ASSIGNMENT_REFRESH_FAILURE",

  ASSIGNMENT_PERFORM_ACTION_REQUEST: "ASSIGNMENT_PERFORM_ACTION_REQUEST",
  ASSIGNMENT_PERFORM_ACTION_SUCCESS: "ASSIGNMENT_PERFORM_ACTION_SUCCESS",
  ASSIGNMENT_PERFORM_ACTION_FAILURE: "ASSIGNMENT_PERFORM_ACTION_FAILURE",

  ASSIGNMENT_PERFORM_REFRESH_REQUEST: "ASSIGNMENT_PERFORM_REFRESH_REQUEST",
  ASSIGNMENT_PERFORM_REFRESH_SUCCESS: "ASSIGNMENT_PERFORM_REFRESH_SUCCESS",
  ASSIGNMENT_PERFORM_REFRESH_FAILURE: "ASSIGNMENT_PERFORM_REFRESH_FAILURE",

  ASSIGNMENT_SAVE_REQUEST: "ASSIGNMENT_SAVE_REQUEST",
  ASSIGNMENT_SAVE_SUCCESS: "ASSIGNMENT_SAVE_SUCCESS",
  ASSIGNMENT_SAVE_FAILURE: "ASSIGNMENT_SAVE_FAILURE",

  ASSIGNMENT_FROM_CASE_REQUEST: "ASSIGNMENT_FROM_CASE_REQUEST",
  ASSIGNMENT_FROM_CASE_SUCCESS: "ASSIGNMENT_FROM_CASE_SUCCESS",
  ASSIGNMENT_FROM_CASE_FAILURE: "ASSIGNMENT_FROM_CASE_FAILURE",

  ASSIGNMENT_SAVE_DATA: "ASSIGNMENT_SAVE_DATA",
  
  ASSIGNMENT_STEP_PREVIOUS_REQUEST: "ASSIGNMENT_STEP_PREVIOUS_REQUEST",
  ASSIGNMENT_STEP_PREVIOUS_SUCCESS: "ASSIGNMENT_STEP_PREVIOUS_SUCCESS",
  ASSIGNMENT_STEP_PREVIOUS_FAILURE: "ASSIGNMENT_STEP_PREVIOUS_FAILURE",

  NEXT_ASSIGNMENT_REQUEST: "NEXT_ASSIGNMENT_REQUEST",
  NEXT_ASSIGNMENT_SUCCESS: "NEXT_ASSIGNMENT_REQUEST",
  NEXT_ASSIGNMENT_FAILURE: "NEXT_ASSIGNMENT_FAILURE",

  WORKLIST_REQUEST: "WORKLIST_REQUEST",
  WORKLIST_SUCCESS: "WORKLIST_SUCCESS",
  WORKLIST_FAILURE: "WORKLIST_FAILURE",
  WORKLIST_SAVE_SETTINGS: "WORKLIST_SAVE_SETTINGS",

  WORKQUEUE_REQUEST: "WORKQUEUE_REQUEST",
  WORKQUEUE_SUCCESS: "WORKQUEUE_SUCCESS",
  WORKQUEUE_FAILURE: "WORKQUEUE_FAILURE",

  VALIDATION_ERROR: "VALIDATION_ERROR",
  NOT_AUTHORIZED_ERROR: "NOT_AUTHORIZED_ERROR",
  UNHANDLED_PEGA_ERROR: "UNHANDLED_PEGA_ERROR",
  CLEAR_ERRORS: "CLEAR_ERRORS",

  ATTACHMENTS_UPLOAD_REQUEST: "ATTACHMENTS_UPLOAD_REQUEST",
  ATTACHMENTS_UPLOAD_SUCCESS: "ATTACHMENTS_UPLOAD_SUCCESS",
  ATTACHMENTS_UPLOAD_FAILURE: "ATTACHMENTS_UPLOAD_FAILURE",

  ATTACHMENTS_REQUEST: "ATTACHMENTS_REQUEST",
  ATTACHMENTS_SUCCESS: "ATTACHMENTS_SUCCESS",
  ATTACHMENTS_FAILURE: "ATTACHMENTS_FAILURE",

  ATTACHMENTS_SAVE_REQUEST: "ATTACHMENTS_SAVE_REQUEST",
  ATTACHMENTS_SAVE_SUCCESS: "ATTACHMENTS_SAVE_SUCCESS",
  ATTACHMENTS_SAVE_FAILURE: "ATTACHMENTS_SAVE_FAILURE",

  ATTACHMENT_DELETE_REQUEST: "ATTACHMENT_DELETE_REQUEST",
  ATTACHMENT_DELETE_SUCCESS: "ATTACHMENT_DELETE_SUCCESS",
  ATTACHMENT_DELETE_FAILURE: "ATTACHMENT_DELETE_FAILURE",

  ATTACHMENT_DOWNLOAD_REQUEST: "ATTACHMENT_DOWNLOAD_REQUEST",
  ATTACHMENT_DOWNLOAD_SUCCESS: "ATTACHMENT_DOWNLOAD_SUCCESS",
  ATTACHMENT_DOWNLOAD_FAILURE: "ATTACHMENT_DOWNLOAD_FAILURE",
};
